import { IUserFields } from "@src/views/login/LoginTypes";
import { createModel } from "hox";
import { useState } from "react";
import useStorageState from "../hooks/useStorageState";
// import menuDataJson from "../data/menuData.json";
import { IMenuNode } from "../layout/FmsMenu";

export type RoleType = {
    id: number,
    name: String,
};
// export type UserType = {
//     id: string,
//     userName: string,
//     token: string,
//     userPassword: string,
//     loginType: 'token' | 'account',

//     createTime?: string,
//     createUser?: string,
//     deleteFlag?: number,
//     orderNumber?: null,
//     roleDetails?: [],
//     salt?: string,
//     staffId?: string,
//     updateTime?: string,
//     updateUser?: string,
//     userAccount?: string,
//     userErrorNumber?: number,
//     userStatus?: string,
// }

type GlobalModelType = {
    user: IUserFields,
    setUser: (e: IUserFields) => void,
    resetUser: () => void,
    toggleMenu: () => void,
    cm: CmType,
    resetCm: () => void,
    initUserState: IUserFields,
    menuData: IMenuNode[],
    setMenuData: (e: IMenuNode[]) => void,
    // createMenu: (e: IMenuItem[]) => void,
};



type CmType = {
    collapsed: boolean
}
const initCmState = {
    collapsed: false
}

// /** 根据菜单地址找到对应的菜单项 */
// const forFind = (array: IMenuNode[], path: string): (IMenuNode | undefined) => {
//     for (const item of array) {
//         if (item.path === path) {
//             return {
//                 ...item,
//                 children: []
//             };
//         } else if (item.children && item.children.length > 0) {
//             let forFindRet = forFind(item.children, path);
//             if (forFindRet) {
//                 return {
//                     ...forFindRet,
//                     children: []
//                 }
//             }
//         }
//     }
//     return undefined
// }
/** 将菜单列表转换为菜单树结构 */
// const data_to_tree = (data: IMenuItem[]) => {
//     const result_tree: { [key: string]: IMenuNode } = {}
//     for (const item of data) {
//         let newObj = forFind(menuDataJson, item.menuUrl, 'path', true);
//         result_tree[item.id] = newObj as IMenuNode
//         if (item.menuParentId in result_tree) {
//             if (!result_tree[item.menuParentId].children) {
//                 result_tree[item.menuParentId].children = []
//             }
//             result_tree[item.menuParentId].children.push(newObj as IMenuNode)
//         }
//     }
//     return Object.values(result_tree).filter(obj => !obj.parent);
// }

function useModel() {
    const initUserState: IUserFields = {
        userName: "",
        userCode: "",
        token: "",
        loginType: 'account',
    }
    const [user, setUser, resetUser] = useStorageState<IUserFields>('user', initUserState);

    const [cm, setCm, resetCm] = useStorageState<CmType>('cm', initCmState);

    const [menuData, setMenuData] = useStorageState<IMenuNode[]>('menuData', []);
    //用户所有资源权限
    const [resourceAuth, setResourceAuth] = useStorageState<string[]>("resource", []);

    const [changePassVisible, setChangePassVisible] = useState(false);

    const [loading, setLoading] = useState({
        spinning: false,
        tip: "Loading..."
    })
    const globalLoading = (spinning = true, tip = "Loading...") => setLoading((value) => ({...value, spinning, tip}))

    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed
        })
    }

    return {
        cm,
        user,
        menuData,
        resourceAuth,
        loading,

        setUser,
        resetUser,
        toggleMenu,
        resetCm,
        initUserState,
        setMenuData,
        changePassVisible,
        setChangePassVisible,
        setResourceAuth,
        // createMenu,
        setLoading,
        globalLoading,
    };
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel;
